import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useAgencyInfo } from "../../../context/agency";
import ModuleConnect from "../components/ModuleConnect";

const LocationIntiater = () => {
  const { companyId } = useParams();
  const [agency] = useAgencyInfo();
  const [iframeLoaded, setIframeLoaded] = useState(false);

  if (!agency?.modulesAuth) {
    return (
      <ModuleConnect
        icon="bi bi-rocket-takeoff"
        title="Connect to Use Location Initiator"
        description="To trigger workflows and onboarding flows on your sub-account locations, connect your GoHighLevel agency account so we can act on your behalf."
      />
    );
  }

  const iframeSrc = `https://form.smartconnector.org/${companyId}/location_intiater`;

  return (
    <div className="li-page">
      <div className="li-frame-wrap">
        {!iframeLoaded && (
          <div className="li-frame-loader d-flex flex-column align-items-center justify-content-center">
            <div className="li-loader-icon d-inline-flex align-items-center justify-content-center mb-3">
              <div
                className="spinner-border text-primary"
                role="status"
                style={{ width: "1.6rem", height: "1.6rem", borderWidth: "2px" }}
              />
            </div>
            <div className="li-loader-title">Loading workspace…</div>
            <div className="li-loader-meta">Connecting to your location initiator</div>
          </div>
        )}
        <iframe
          id="li-iframe"
          src={iframeSrc}
          title="Location Initiator"
          onLoad={() => setIframeLoaded(true)}
          className={`li-frame ${iframeLoaded ? "is-loaded" : ""}`}
        />
      </div>

      <style>{`
        .li-page {
          font-family: 'Inter', sans-serif;
          background: #fafafa;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }
        .li-frame-wrap {
          position: relative;
          flex: 1;
          min-height: 0;
        }
        .li-frame {
          width: 100%;
          height: 100%;
          min-height: 100vh;
          border: none;
          background: transparent;
          display: block;
          opacity: 0;
          transition: opacity 0.25s ease;
        }
        .li-frame.is-loaded { opacity: 1; }

        .li-frame-loader {
          position: absolute;
          inset: 0;
          background: #fafafa;
          z-index: 1;
        }
        .li-loader-icon {
          width: 56px;
          height: 56px;
          border-radius: 16px;
          background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);
          border: 1px solid #e0e7ff;
          box-shadow: 0 4px 14px rgba(79, 70, 229, 0.12);
        }
        .li-loader-title {
          font-size: 0.9375rem;
          font-weight: 600;
          color: #0f172a;
          letter-spacing: -0.005em;
        }
        .li-loader-meta {
          font-size: 0.8125rem;
          color: #6b7280;
          margin-top: 4px;
        }
      `}</style>
    </div>
  );
};

export default LocationIntiater;
